import { call, put, select, take } from 'redux-saga/effects';
import { Types, CrossSellItemsResponseProps } from './types';
import {
  loadCrossSellItems,
  loadCrossSellItemsSuccess,
  loadCrossSellItemsFailure
} from './actions';
import { CrossSellService } from '../../../services/CrossSell';
import { AxiosInstance } from 'axios';
import { IUserState } from '../user/types';
import { ApplicationState } from '../..';
import { CustomersState } from '../customers/types';
import { Types as CustomerTypes } from '../../ducks/customers/types';
import { executeTagging } from '../../../components/Tagging';
import { ILongSteelShoppingCartState } from '../long-steel-shopping-cart/types';
import { NewCartItem } from '../../../services/MVP/models';

interface CrossSellParams {
  payload: {
    cartItems?: NewCartItem[];
    divisions?: string[];
    businessPartners: string[];
    soldTo?: string;
    commerceApi: AxiosInstance;
    useNewFlow: boolean;
    scope?: string;
  };
  type: Types;
}
export function* loadCrossSellItemsSaga(params: CrossSellParams) {
  try {
    const service = new CrossSellService();

    const serviceResponse: CrossSellItemsResponseProps = yield call(
      [service, service.getCrossSellItems],
      {
        cartItems: params.payload.cartItems,
        divisions: params.payload.divisions,
        businessPartners: params.payload.businessPartners,
        soldTo: params.payload.soldTo,
        commerceApi: params.payload.commerceApi,
        useNewFlow: params.payload.useNewFlow,
        scope: params.payload.scope
      }
    );

    const userState: IUserState = yield select(
      (state: ApplicationState) => state.user
    );
    let customersState: CustomersState = yield select(
      (state: ApplicationState) => state.customers
    );

    const cartState: ILongSteelShoppingCartState = yield select(
      (state: ApplicationState) => state.longSteelShoppingCart
    );

    if (customersState.loading) {
      yield take(CustomerTypes.LOAD_CUSTOMERS_SUCCESS);

      customersState = yield select(
        (state: ApplicationState) => state.customers
      );
    }

    const filteredItems = serviceResponse.items.filter(
      (product) =>
        !!product.price?.creditPrice && Number(product.price?.creditPrice) > 0
    );

    const qtyItems = filteredItems.length;

    if (qtyItems && qtyItems > 0 && userState && customersState && cartState) {
      const tagging = {
        select_emissor: cartState.emitterId,
        select_recebedor: cartState.receiverId,
        select_emissor_pedido: params.payload.soldTo,
        event: 'cross_sell_impression',
        screenName:
          params.payload.scope === 'details'
            ? 'LG:Detalhes_do_pedido'
            : params.payload.scope === 'orders'
            ? 'LG:MeusPedidos'
            : 'carrinho',
        tipo_compra:
          params.payload.scope === 'details' ||
          params.payload.scope === 'orders'
            ? null
            : localStorage.getItem('tipo_compra'),
        recommendation_details: {
          qty_items: qtyItems
        },
        items: filteredItems.map((item, index) => ({
          item_id: item.sku,
          item_name: item.name,
          index: index,
          price: item.price.creditPrice
        }))
      };

      yield executeTagging({ ...tagging, userState, customersState });
    }

    yield put(loadCrossSellItemsSuccess(serviceResponse));
  } catch (err) {
    console.error('loadCrossSellItemsSaga', err);
    yield put(loadCrossSellItemsFailure(err));
  }
}

export function* checkCrossSellAvailableSaga(params: CrossSellParams) {
  try {
    const service = new CrossSellService();
    const hasCrossSell: boolean = yield call(
      [service, service.hasCrossSellItems],
      {
        businessPartners: params.payload.businessPartners,
        soldTo: params.payload.soldTo,
        commerceApi: params.payload.commerceApi,
        scope: params.payload.scope
      }
    );

    if (hasCrossSell) {
      yield put(loadCrossSellItems(params.payload));
    }
  } catch {
    //
  }
}
